import {
  FETCH_EQUIPMENT_DATA,
  FETCH_EQUIPMENT_DATA_SUCCESS,
  FETCH_EQUIPMENT_DATA_FAILURE,
  FETCH_CONSUMABLES_DATA,
  FETCH_CONSUMABLES_DATA_SUCCESS,
  FETCH_CONSUMABLES_DATA_FAILURE,
  FETCH_QC_INSPECTION_PERSONNEL_DATA,
  FETCH_QC_INSPECTION_PERSONNEL_DATA_SUCCESS,
  FETCH_QC_INSPECTION_PERSONNEL_DATA_FAILURE,
  REFRESH_EQUIPMENT_DATA,
  REFRESH_CONSUMABLES_DATA,
  REFRESH_QC_INSPECTION_PERSONNEL_DATA,
  FETCH_REGISTRY_MISCELLANEOUS_DATA,
  FETCH_REGISTRY_MISCELLANEOUS_DATA_SUCCESS,
  FETCH_REGISTRY_MISCELLANEOUS_DATA_FAILURE,
  REFRESH_REGISTRY_MISCELLANEOUS_DATA,
} from "./types";

const initialState = {
  // Equipment data stored by project_id
  equipmentData: {}, // { [projectId]: { Welding: [], NDE: [], QC: [] } }
  // Consumables data stored by project_id
  consumablesData: {}, // { [projectId]: { "NDE Consumables": [] } }
  // QC Inspection Personnel data stored by project_id
  inspectionPersonnelData: {}, // { [projectId]: [...] }
  registryMiscellaneousData: {}, // { [projectId]: [...] } flattened rows
  // Loading states
  equipmentLoading: false,
  consumablesLoading: false,
  inspectionPersonnelLoading: false,
  registryMiscellaneousLoading: false,
  // Error states
  equipmentError: null,
  consumablesError: null,
  inspectionPersonnelError: null,
  registryMiscellaneousError: null,
};

const registryDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // Equipment Cases
    case FETCH_EQUIPMENT_DATA: {
      return {
        ...state,
        equipmentLoading: true,
        equipmentError: null,
      };
    }

    case FETCH_EQUIPMENT_DATA_SUCCESS: {
      const { projectId, data } = action.payload;
      return {
        ...state,
        equipmentData: {
          ...state.equipmentData,
          [projectId]: data
        },
        equipmentLoading: false,
        equipmentError: null,
      };
    }

    case FETCH_EQUIPMENT_DATA_FAILURE: {
      return {
        ...state,
        equipmentLoading: false,
        equipmentError: action.error,
      };
    }

    // Consumables Cases
    case FETCH_CONSUMABLES_DATA: {
      return {
        ...state,
        consumablesLoading: true,
        consumablesError: null,
      };
    }

    case FETCH_CONSUMABLES_DATA_SUCCESS: {
      const { projectId, data } = action.payload;
      return {
        ...state,
        consumablesData: {
          ...state.consumablesData,
          [projectId]: data
        },
        consumablesLoading: false,
        consumablesError: null,
      };
    }

    case FETCH_CONSUMABLES_DATA_FAILURE: {
      return {
        ...state,
        consumablesLoading: false,
        consumablesError: action.error,
      };
    }

    // QC Inspection Personnel Cases
    case FETCH_QC_INSPECTION_PERSONNEL_DATA: {
      return {
        ...state,
        inspectionPersonnelLoading: true,
        inspectionPersonnelError: null,
      };
    }

    case FETCH_QC_INSPECTION_PERSONNEL_DATA_SUCCESS: {
      const { projectId, data } = action.payload;
      return {
        ...state,
        inspectionPersonnelData: {
          ...state.inspectionPersonnelData,
          [projectId]: data
        },
        inspectionPersonnelLoading: false,
        inspectionPersonnelError: null,
      };
    }

    case FETCH_QC_INSPECTION_PERSONNEL_DATA_FAILURE: {
      return {
        ...state,
        inspectionPersonnelLoading: false,
        inspectionPersonnelError: action.error,
      };
    }

    // Refresh Cases - Clear cached data to force refetch
    case REFRESH_EQUIPMENT_DATA: {
      const { projectId } = action.payload;
      const newEquipmentData = { ...state.equipmentData };
      delete newEquipmentData[projectId];
      return {
        ...state,
        equipmentData: newEquipmentData,
      };
    }

    case REFRESH_CONSUMABLES_DATA: {
      const { projectId } = action.payload;
      const newConsumablesData = { ...state.consumablesData };
      delete newConsumablesData[projectId];
      return {
        ...state,
        consumablesData: newConsumablesData,
      };
    }

    case REFRESH_QC_INSPECTION_PERSONNEL_DATA: {
      const { projectId } = action.payload;
      const newInspectionPersonnelData = { ...state.inspectionPersonnelData };
      delete newInspectionPersonnelData[projectId];
      return {
        ...state,
        inspectionPersonnelData: newInspectionPersonnelData,
      };
    }

    case FETCH_REGISTRY_MISCELLANEOUS_DATA: {
      return {
        ...state,
        registryMiscellaneousLoading: true,
        registryMiscellaneousError: null,
      };
    }

    case FETCH_REGISTRY_MISCELLANEOUS_DATA_SUCCESS: {
      const { projectId, data } = action.payload;
      return {
        ...state,
        registryMiscellaneousData: {
          ...state.registryMiscellaneousData,
          [projectId]: data,
        },
        registryMiscellaneousLoading: false,
        registryMiscellaneousError: null,
      };
    }

    case FETCH_REGISTRY_MISCELLANEOUS_DATA_FAILURE: {
      return {
        ...state,
        registryMiscellaneousLoading: false,
        registryMiscellaneousError: action.error,
      };
    }

    case REFRESH_REGISTRY_MISCELLANEOUS_DATA: {
      const { projectId } = action.payload;
      const next = { ...state.registryMiscellaneousData };
      delete next[projectId];
      return {
        ...state,
        registryMiscellaneousData: next,
      };
    }

    default:
      return state;
  }
};

export default registryDataReducer;

